if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  function abDecorateCurrencyList(root) {
    var ul = root && root.querySelector('[data-currency-list]');
    if (!ul || ul.__abCurDone) return;
    var items = Array.prototype.slice.call(ul.querySelectorAll('li[data-cur]'));
    if (!items.length) return;
    var PRIMARY = { AUD:'AU', USD:'US', NZD:'NZ', GBP:'GB', EUR:'DE', CAD:'CA', JPY:'JP', CNY:'CN', CHF:'CH', SGD:'SG', HKD:'HK', INR:'IN', ZAR:'ZA', AED:'AE' };
    var POPULAR = ['AUD', 'NZD', 'USD', 'GBP', 'EUR'];
    function flag(cc) {
      cc = (cc || '').toUpperCase();
      if (cc === 'EU') return '🇪🇺';
      if (cc.length !== 2) return '🌐';
      var a = cc.charCodeAt(0), b = cc.charCodeAt(1);
      if (a < 65 || a > 90 || b < 65 || b > 90) return '🌐';
      try { return String.fromCodePoint(0x1F1E6 + a - 65) + String.fromCodePoint(0x1F1E6 + b - 65); } catch (e) { return '🌐'; }
    }
    var byCur = {};
    items.forEach(function (li) {
      var cur = li.getAttribute('data-cur'); if (!cur) return;
      var cc = li.getAttribute('data-cc');
      var cand = byCur[cur];
      if (!cand) { byCur[cur] = li; return; }
      if (li.getAttribute('data-current') === '1') { byCur[cur] = li; return; }
      if (cand.getAttribute('data-current') === '1') return;
      if (PRIMARY[cur] && cc === PRIMARY[cur]) { byCur[cur] = li; }
    });
    var kept = [];
    Object.keys(byCur).forEach(function (cur) {
      var li = byCur[cur];
      var cc = li.getAttribute('data-cc'), sym = li.getAttribute('data-sym') || '';
      var fEl = li.querySelector('.cur-flag'); if (fEl) fEl.textContent = (cur === 'EUR' ? '🇪🇺' : flag(cc)) + ' ';
      var lEl = li.querySelector('.cur-label'); if (lEl) lEl.textContent = cur + ' ' + sym;
      kept.push({ li: li, cur: cur, pop: POPULAR.indexOf(cur) });
    });
    kept.sort(function (x, y) {
      var xp = x.pop >= 0, yp = y.pop >= 0;
      if (xp && yp) return x.pop - y.pop;
      if (xp) return -1;
      if (yp) return 1;
      return x.cur < y.cur ? -1 : (x.cur > y.cur ? 1 : 0);
    });
    var frag = document.createDocumentFragment();
    var popHead = false, allHead = false;
    function header(txt) { var l = document.createElement('li'); l.className = 'cur-head'; l.setAttribute('aria-hidden', 'true'); l.textContent = txt; return l; }
    kept.forEach(function (k) {
      if (k.pop >= 0 && !popHead) { frag.appendChild(header('Popular')); popHead = true; }
      if (k.pop < 0 && !allHead) { frag.appendChild(header('All currencies')); allHead = true; }
      frag.appendChild(k.li);
    });
    ul.innerHTML = '';
    ul.appendChild(frag);
    ul.__abCurDone = true;
  }

  const abRegisterLocalizationForm = () => {
      Alpine.data('xLocalizationForm', () => ({
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            try { abDecorateCurrencyList(optionEL); } catch (e) {}
            try { if (window.Alpine && window.Alpine.initTree) window.Alpine.initTree(optionEL); } catch (e) {}
            if (!optionEL.__abWired) {
              optionEL.__abWired = 1;
              optionEL.addEventListener('click', function (ev) {
                var li = ev.target && ev.target.closest ? ev.target.closest('li[data-cc]') : null;
                if (!li) return;
                ev.preventDefault(); ev.stopPropagation();
                li.setAttribute('data-ab-loading', '1');
                optionEL.classList.add('ab-cur-loading');
                var form = countrySelector.closest('form') || countrySelector.querySelector('form');
                var inp = form && form.querySelector('[name=country_code]');
                if (inp && form) { inp.value = li.getAttribute('data-cc'); form.submit(); }
              });
            }
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }));
  };
  if (window.Alpine && window.Alpine.store) {
    abRegisterLocalizationForm();
  } else {
    document.addEventListener('alpine:init', abRegisterLocalizationForm);
  }
}
